import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CareerChecklistStore {
  private _planUnlocked = signal<boolean>(false);
  readonly generatePlanUnlocked = this._planUnlocked.asReadonly();

  private _planGenerated = signal<boolean>(false);
  readonly buildPlanGenerated = this._planGenerated.asReadonly();

  setGeneratePlanUnlock() {
    this._planUnlocked.set(true);
  }

  resetGeneratePlanUnlock() {
    this._planUnlocked.set(false);
    this._planGenerated.set(false);
  }

  setBuildPlanGenerate() {
    this._planGenerated.set(true);
  }
}
